import { StoreFinderButtonProps } from "@omni/types/components/props/storeFinderButton.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";
import { ReactNode } from "react";
import { useSelector } from "react-redux";

import { StoreFinderButtonContextProvider } from "@/components/Navigation/Buttons/StoreFinderButton/context/storeFinderButton.context";
import * as HeaderSelectors from "@/redux/modules/value/header/header.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { GetStoreStrategy } from "@/services/store.service";
import { useIsClientSide } from "@/utils/hooks/isClient.hook";
import { useStore } from "@/utils/hooks/store/useStore.hook";

import { getStoreInfo } from "../../../Store/utils/storeInfo";
import { useStoreFullName } from "../../../Store/utils/useStoreFullName.hook";

export type Props = StoreFinderButtonProps<BaseStore> & {
    children: ReactNode;
};

export const Base = ({
    icon,
    text,
    invert,
    alerts,
    ariaLabel,
    invertMobile,
    link,
    textHidden,
    children
}: Props) => {
    const mobile = useSelector(HeaderSelectors.isMobile);
    const isClientSide = useIsClientSide();
    const { t } = useGranite();

    const { store } = useStore({
        strategy: GetStoreStrategy.Customer
    });

    const storeFullName = useStoreFullName(store);

    return (
        <StoreFinderButtonContextProvider
            headerButtonProps={{
                icon: icon,
                text: store
                    ? `${storeFullName} - ${getStoreInfo(store, t).text}`
                    : text,
                ariaLabel: ariaLabel,
                hover: !!store,
                invert: invert || (isClientSide && mobile),
                invertMobile: invertMobile,
                link: link,
                alerts: alerts,
                textHidden: textHidden
            }}
            store={store}
        >
            {children}
        </StoreFinderButtonContextProvider>
    );
};
